import React from 'react'
import PropTypes from 'prop-types'
import Row from '../../../bootstrap/component/Row'
import Column from '../../../bootstrap/component/Column'
import LabelInput from '../../../form/component/LabelInput'
import Select from '../../../form/component/Select'
import ContentBox from '../../../layout/component/ContentBox'
import renderUserName from './renderUserName'

const UserSelection = ({ userList, createUser, currentUserId, changeCurrentUserId, createEmployee, createExternalUser }) => {
    return (
        <ContentBox title="Manage User">
            <Row>
                <Column size={6}>
                    <LabelInput label="Choose User">
                        <Select
                            style={{ height: '30px' }}
                            object={{ currentUserId }}
                            name="currentUserId"
                            renderer={renderUserName}
                            valueList={userList}
                            addEmpty={true}
                            onChange={changeCurrentUserId}
                        />
                    </LabelInput>
                </Column>
                <Column size={6}>
                    <div style={{ marginTop: '24px' }}>
                        <button
                            className="btn btn-warning btn-sm"
                            onClick={createEmployee}>
                            <i className="fa fa-plus-square"/>
                            &#160;new employee
                        </button>
                        &#160;
                        <button
                            className="btn btn-warning btn-sm"
                            onClick={createExternalUser}>
                            <i className="fa fa-plus-square"/>
                            &#160;new external user
                        </button>
                    </div>
                </Column>
            </Row>
        </ContentBox>
    )
}

UserSelection.propTypes = {
    userList: PropTypes.array.isRequired,
    currentUserId: PropTypes.string,
    createUser: PropTypes.func.isRequired,
    changeCurrentUserId: PropTypes.func.isRequired,
    createEmployee: PropTypes.func.isRequired,
    changeExternalUser: PropTypes.func.isRequired,
}

export default UserSelection



// WEBPACK FOOTER //
// ./src/modules/security/component/manage/UserSelection.js